import Glide from '@glidejs/glide';
import $ from 'jquery';

$( window ).on( 'load', () => {

if( $( '.glide' ).length ) {  
  var slider = document.querySelectorAll( '.slider' );

  if( $( slider ).length ){
    for ( var i = 0; i < slider.length; i++ ) {
      new Glide( slider[i], {
        type: 'carousel',
        animationDuration: 600,
        perTouch: 1,
        perView: 2, 
        touchRatio: 1,
        peek: {
          before: 60, 
          after: 200 }, 
        gap: 60, 
        breakpoints: {
          767: {
            perView:1, 
            peek: {
              before: 10, 
              after: 120 }, 
            gap: 20
            }
          }
        } ).mount()
      }
    }
  }

  if ( $( '.slider-threejs' ).length ) {
  
    var totalSlides = $( '.slide' ).length;
    var firstSlide = $('.slide[data-slide="1"]');
    var firstNav = $('.slide-nav[data-slide-nav="1"]');
    var timerLength = $('.slider-threejs').data( 'timer' );
    
    firstSlide.addClass( 'active' ); 
    firstNav.addClass( 'active' ); 

    function playSlides() {
      if( $('.slide.active').data('slide') == totalSlides ) {
        $('.slide.active').removeClass('active')        
        $( firstSlide ).addClass( 'active' )
        $('.slide-nav.active').removeClass('active')  
        $( firstNav ).addClass( 'active' )
      } else {
        $('.slide.active').removeClass('active')        
        .next().addClass('active')  
        $('.slide-nav.active').removeClass('active')        
        .next().addClass('active')  
      }
    }
  
    var timer = setInterval( function(){ playSlides() }, timerLength);
    
      $( '.slide-nav' ).on( 'click', function() {
        clearInterval(timer);
        var slideNumber = $(this).data('slide-nav');
        $('.slide').removeClass( 'active' );
        $('.slide-nav').removeClass( 'active' );
        $('.slide[data-slide="' + slideNumber +'"]').addClass( 'active');
        $(this).addClass( 'active');
        timer = setInterval( function(){ playSlides() }, timerLength);
    } )
  }

});